import React, { Component } from 'react';
import { translate } from 'react-polyglot';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Modal from '../Modal';
import Link from '../Link';
import Tabs from '../Tabs';
import Tab from '../Tab';
import Button from '../Button';

import './TranslationTipsModal.scss';
import './Modal.scss';

class Collapsible extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: props.isOpen || false
    };

    this.toggleOpen = this.toggleOpen.bind(this);
  }

  toggleOpen() {
    this.setState({
      open: !this.state.open
    });
  }

  render() {
    const { title } = this.props;
    const baseClassName = 'pb-collapsible';

    let titleEl;
    if (title) {
      titleEl = <Link parentClassName={`${baseClassName}__title`} onClick={this.toggleOpen}>
        {title}
      </Link>;
    }

    const classes = {
      [baseClassName]: true,
      [`${baseClassName}--active`]: this.state.open
    }

    let children;
    // add toggle to title
    if(this.props.children) {
      children = React.Children.toArray(this.props.children).map((child, index) => {
        return (index === 0) ? React.cloneElement(child, {onClick: this.toggleOpen}) : child;
      })
    }

    return (
      <div className={classNames(classes)}>
        {titleEl}
        <div className={`${baseClassName}__content`}>{children}</div>
      </div>
    );
  }
}

Collapsible.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
  isOpen: PropTypes.bool
};

class TranslationTipsModal extends Component {

  handlePlayTutorial = () => {
    this.props.onClose(); 
    this.props.playTutorialClicked()
  }

  render() {
    const { t } = this.props;
    const baseClassName = "pb-inner-modal";

    return (
      <Modal onClose={this.props.onClose} parentClassName={baseClassName}>
        <div className={`${baseClassName}__heading-wrapper`}>
          <h2 className={`${baseClassName}__title`}>{t('TipsModal.title')}</h2>
          { 
            this.props.showPlayTutorial 
              ?
              <div className={`${baseClassName}__button-wrapper`}>
                <Button
                  label={t('TipsModal.play-tutorial')}
                  variant="primary"
                  size="m"
                  onClick={this.handlePlayTutorial}
                />
              </div>
              :
              null
          }
        </div>

        <Collapsible title={t('TipsModal.offline-translation-faqs-heading')} isOpen={true}>
          <p className={`${baseClassName}__section-title`}>{t('TipsModal.offline-translation-faqs-heading')}</p>
          <p>{t('TipsModal.offline-translation-faqs-text')}</p>
          <ul className={`${baseClassName}__offline-translation-tips`}>
            <li>{t('TipsModal.offline-translation-faq-1')}<br/>
              {t('TipsModal.offline-translation-faq-1-answer')}
            </li>
            <li>{t('TipsModal.offline-translation-faq-2')}<br/>
              {t('TipsModal.offline-translation-faq-2-answer')}
            </li>
            <li>{t('TipsModal.offline-translation-faq-3')}<br/>
              {t('TipsModal.offline-translation-faq-3-answer')}
            </li>
            <li>{t('TipsModal.offline-translation-faq-4')}<br/>
              {t('TipsModal.offline-translation-faq-4-answer')}
            </li>
          </ul>
        </Collapsible>

        <Collapsible title={t('TipsModal.level-appropriate-use-of-language')}>
          <p className={`${baseClassName}__section-title`}>{t('TipsModal.level-appropriate-use-of-language')}</p>
          <p>{t('TipsModal.level-appropriate-use-of-language-tip')}</p>

          <Tabs align="left" parentClassName={`${baseClassName}__tabs`} translationTips>
            <Tab title={t('TipsModal.level-1-emergent-readers')} noPadding>
              <p className={`${baseClassName}__level-content`}>{t('TipsModal.level-1-emergent-readers-content')} <p className={`${baseClassName}__level-content--note`}>{t('TipsModal.level-1-emergent-readers-content-note')}</p></p>
            </Tab>
            <Tab title={t('TipsModal.level-1')} noPadding>
              <p className={`${baseClassName}__level-content`}>{t('TipsModal.level-1-content')}</p>
            </Tab>
            <Tab title={t('TipsModal.level-2')} noPadding>
              <p className={`${baseClassName}__level-content`}>{t('TipsModal.level-2-content')}</p>
            </Tab>
            <Tab title={t('TipsModal.level-3')} noPadding>
              <p className={`${baseClassName}__level-content`}>{t('TipsModal.level-3-content')}</p>
            </Tab>
            <Tab title={t('TipsModal.level-4')} noPadding>
              <p className={`${baseClassName}__level-content`}>{t('TipsModal.level-4-content')}</p>
            </Tab>
          </Tabs>
        </Collapsible>

        <Collapsible title={t('TipsModal.translating-titles-puns-and-idioms')}>
          <p className={`${baseClassName}__section-title`}>{t('TipsModal.translating-titles-puns-and-idioms')}</p>
          <p>{t('TipsModal.translating-titles-puns-and-idioms-tip')}</p>
        </Collapsible>

        <Collapsible title={t('TipsModal.cultural-references-and-settings')}>
          <p className={`${baseClassName}__section-title`}>{t('TipsModal.cultural-references-and-settings')}</p>
          <p>{t('TipsModal.cultural-references-and-settings-tip')}</p>
        </Collapsible>

        <Collapsible title={t('TipsModal.proper-nouns-and-names-in-translation')}>
          <p className={`${baseClassName}__section-title`}>{t('TipsModal.proper-nouns-and-names-in-translation')}</p>
          <p>{t('TipsModal.proper-nouns-and-names-in-translation-tip')}</p>
        </Collapsible>

        <Collapsible title={t('TipsModal.transliteration')}>
          <p className={`${baseClassName}__section-title`}>{t('TipsModal.transliteration')}</p>
          <p>{t('TipsModal.transliteration-tip')}</p>
        </Collapsible>

        <Collapsible title={t('TipsModal.translating-sounds')}>
          <p className={`${baseClassName}__section-title`}>{t('TipsModal.translating-sounds')}</p>
          <p>{t('TipsModal.translating-sounds-tip')}</p>
        </Collapsible>

        <Collapsible title={t('TipsModal.translating-STEM-stories')}>
          <p className={`${baseClassName}__section-title`}>{t('TipsModal.translating-STEM-stories')}</p>
          <p>{t('TipsModal.translating-STEM-stories-tip')}</p>
        </Collapsible>

        <Collapsible title={t('TipsModal.best-practices')}>
          <p className={`${baseClassName}__section-title`}>{t('TipsModal.best-practices')}</p>
          <p>{t('TipsModal.best-practices-tip')}</p>
        </Collapsible>
      </Modal>
    );
  }
};

export default translate()(TranslationTipsModal);



// WEBPACK FOOTER //
// ./src/components/OfflineTranslate/TranslationTipsModal.jsx